interface IENV {
  appCode: string
  /** merchandising-service gateway — every endpoint this console calls, lookups included. */
  apiEndpoint: string
  envType?: string
  portalGetway: string
  /** chat-service through the gateway, for the topbar's Chat launcher. Empty = no launcher. */
  chatGetway: string
  portalURL?: string
  /**
   * Origin of `portalURL` — the Portal host, for cross-app links such as the profile menu.
   * Derived once here rather than at each call site, which is how two of those links ended up
   * hardcoded to portal.erpboi.com. Empty string when portalURL is unset or malformed.
   */
  portalOrigin: string
  /** This console's name, "Merchandising" — part of the browser tab title. */
  appName: string
  /** Product name shown in the UI and appended to the browser tab title. */
  brandName: string
  /** Public path to this deployment's logo — the fallback when a company has no uploaded logo. */
  brandLogo: string
  /** Public path to this deployment's favicon. */
  brandFavicon: string
  /** Support address shown on the Help page. */
  supportEmail: string
}

const originOf = (url?: string): string => {
  try {
    return new URL(url || '').origin
  } catch {
    return ''
  }
}

export const ENV: IENV = {
  appCode: process.env.REACT_APP_CODE || '',
  envType: process.env.REACT_APP_ENV_TYPE || '',
  apiEndpoint: process.env.REACT_APP_GETWAY || '',
  portalURL: process.env.REACT_APP_PORTAL_URL || '',
  portalGetway: process.env.REACT_APP_PORTAL_GETWAY || '',
  chatGetway: process.env.REACT_APP_CHAT_GETWAY || '',
  portalOrigin: originOf(process.env.REACT_APP_PORTAL_URL),
  appName: process.env.REACT_APP_APP_NAME || 'Merchandising',
  brandName: process.env.REACT_APP_BRAND_NAME || 'ErpBoi',
  brandLogo: process.env.REACT_APP_BRAND_LOGO || '/media/logos/logo.png',
  brandFavicon: process.env.REACT_APP_BRAND_FAVICON || '/media/logos/favicon.ico',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@erpboi.com',
}
